import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { class: "absolute z-60 h-screen bg-gray-100 font-sans text-gray-900 antialiased" }
const _hoisted_4 = { class: "mx-auto w-full p-4 sm:px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_NotificationsProvider = _resolveComponent("NotificationsProvider")!
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Sidebar, {
      sidebarOpen: _ctx.sidebarOpen,
      onCloseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebarOpen = false))
    }, null, 8, ["sidebarOpen"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NotificationsProvider)
      ]),
      _createVNode(_component_Header, {
        sidebarOpen: _ctx.sidebarOpen,
        onToggleSidebar: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarOpen = !_ctx.sidebarOpen))
      }, null, 8, ["sidebarOpen"]),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}